module.exports = __webpack_public_path__ + "img/magazine@2x.97b6a3a.webp";